import {resources} from "../../../../../../../core/models/resource/resources";

export const productCompositionsResourceType = resources['product-compositions'];
export const productCompositionFilesResourceType = resources['product-composition-files'];
